import SlidingPanel from "@components/sliders/SlidingPanel";
import { ChatMessageData } from "@services/models/Prime/ChatHistoryModel";
import React from "react";

interface DisplayFileSlidingPanelProps {
  isOpen: boolean;
  onClose: () => void;
  chatMessageData: ChatMessageData;
}
const DisplayFileSlider: React.FC<DisplayFileSlidingPanelProps> = ({
  isOpen,
  onClose,
  chatMessageData,
}) => {
  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={"File"}
      onClose={onClose}
      onClickCross={onClose}
      showConfirm={false}
    >
      <div className={`flex flex-col px-[16px]  pb-[16px]`}>
        {chatMessageData &&
          (chatMessageData.messageType === "image" ? (
            <img
              src={chatMessageData.messageContent}
              alt="image"
              className="max-h-[400px]"
            />
          ) : (
            <video
              src={chatMessageData.messageContent}
              controls
              className="max-w-full max-h-[400px]"
            />
          ))}
      </div>
    </SlidingPanel>
  );
};

export default DisplayFileSlider;
